module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/keepCool-513e2dc5847d4f1af6d7556ebba5f062.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/keepCool.png
// module id = 2449
// module chunks = 2